module.exports = __webpack_public_path__ + "img/mindpod-interactions.8461c340.gif";